export default __webpack_public_path__ + "13c4ae3f611560416cebd885c6505fed.webp";